var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.42.59A1.985 1.985 0 0 0 18.003 0h-5.488c-.36 0-.705.143-.96.397L.584 11.365a2 2 0 0 0 0 2.827l5.223 5.223a2.001 2.001 0 0 0 2.827 0L19.602 8.451c.254-.255.397-.6.398-.96V2a1.974 1.974 0 0 0-.58-1.41Zm-3.706 5.124a1.428 1.428 0 1 1 0-2.857 1.428 1.428 0 0 1 0 2.857Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tag.48a1e6338fe50846c1161983ef5d7797.svg";